import React, { useState } from "react";

import { THEMES } from "../constants/themeConstants";

const initialThemeContext = {
  theme: THEMES.DEFAULT,
  setTheme: (theme) => {},
};

export const ThemeContext = React.createContext(initialThemeContext);

export default function ThemeProvider({ children }) {
  const initialState = () => {
    const storedTheme = localStorage.getItem("theme");

    return storedTheme ? JSON.parse(storedTheme) : THEMES.DEFAULT;
  };

  const [theme, _setTheme] = useState(initialState());

  const setTheme = (theme) => {
    localStorage.setItem("theme", JSON.stringify(theme));
    _setTheme(theme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
